module.exports = __webpack_public_path__ + "img/404.47760d7a.png";